import { module } from 'angular';

import { default as scriptArgumentServiceName, ScriptArgumentService } from './script-argument.service';

export default module('contact.agent.core.phone.script-argument', []).service(scriptArgumentServiceName, ScriptArgumentService).name;
